import { DARK_MODE_COLORS } from './constants';

export const fmt = (num) => new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
}).format(Number(num || 0));

export const parseDateOnly = (value) => {
  if (!value) return null;
  if (value instanceof Date) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }

  const text = String(value).slice(0, 10);
  const [year, month, day] = text.split('-').map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day);
};

export const startOfDayIso = (value) => {
  const date = parseDateOnly(value);
  if (!date) return null;
  date.setHours(0, 0, 0, 0);
  return date.toISOString();
};

export const nextDayStartIso = (value) => {
  const date = parseDateOnly(value);
  if (!date) return null;
  date.setDate(date.getDate() + 1);
  date.setHours(0, 0, 0, 0);
  return date.toISOString();
};

export const toLocalDateString = (value) => {
  const date = value instanceof Date ? value : parseDateOnly(value);
  if (!date) return null;
  const tz = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - tz).toISOString().split('T')[0];
};

export const getGroupingKey = (dateString, grouping) => {
  const date = parseDateOnly(dateString);
  if (!date) return dateString;
  const year = date.getFullYear();
  if (grouping === 'year') return year.toString();
  const month = date.getMonth() + 1;
  if (grouping === 'month') return `${year}-${month.toString().padStart(2, '0')}`;
  if (grouping === 'week') {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    const weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
    return `${d.getUTCFullYear()}-W${weekNo.toString().padStart(2, '0')}`;
  }
  return dateString; 
};

export const calculateYoYDifference = (dataRow, latestYear, prevYear) => {
    if (!dataRow || !prevYear || !latestYear) return null;
    const latestVal = dataRow[latestYear] || 0;
    const prevVal = dataRow[prevYear] || 0;
    if (prevVal === 0) return latestVal > 0 ? { diff: '+100%', color: DARK_MODE_COLORS.GROWTH_POSITIVE } : null;
    const growth = ((latestVal - prevVal) / prevVal) * 100;
    const prefix = growth >= 0 ? '+' : '';
    const color = growth >= 0 ? DARK_MODE_COLORS.GROWTH_POSITIVE : DARK_MODE_COLORS.GROWTH_NEGATIVE; 
    return { diff: `${prefix}${growth.toFixed(1)}%`, color };
};
